import styled from 'styled-components'

export const FilterType = styled.div`


	${props => props.active ? 'color: #0061bd;': ''};
	cursor: pointer;

`;